export class PictureColumn {
  order: number;
  pictures: Picture[];

  constructor(order: number) {
    this.order = order;
    this.pictures = [];
  }
}

export class Picture {
  id?: string;
  order: number;
  name: string;
  description: string;
  legend: string;
  width: number;
  height: number;
  src: string;

  constructor(order: number) {
    this.order = order;
  }

  // helper
  uploadSrc?: string;
  file?: File;
}
